export {AvatarWrapped} from './components/avatar-wrapped/avatar-wrapped';
export type {AvatarWrappedProps} from './components/avatar-wrapped/avatar-wrapped';
export {default as AvatarGroup} from './components/avatar-group/avatar-group';
export {default as Item} from './components/avatar-item/avatar-item';
export {Avatar as default, Avatar} from './avatar';
export type {AvatarProps} from './avatar';
export {Size} from './constants';
export type {SizesVariantsTypes} from './constants';
export type {Name, FullName} from './typedef';
